export default __webpack_public_path__ + "static/media/icon-d.8417fd28.svg";